var specialController = null;
function initSpecialAnimation() {
  specialController = new ScrollMagic.Controller();
  new ScrollMagic.Scene({triggerElement: ".special .title", triggerHook: 1, duration: 1000})
    .setTween(gsap.fromTo(".special__star", { translateY: "50%"}, { translateY: "-30%"}))
    .addTo(specialController);

  new ScrollMagic.Scene({triggerElement: ".special", triggerHook: 1, duration: 1000})
    .setTween(gsap.fromTo(".special .title", { translateY: "30%"}, { translateY: "-20%"}))
    .addTo(specialController);

  new ScrollMagic.Scene({triggerElement: ".special", triggerHook: 1, duration: 1000})
    .setTween(gsap.fromTo(".special .text", { translateY: "150%"}, { translateY: "-60%"}))
    .addTo(specialController);
  new ScrollMagic.Scene({triggerElement: ".special .title", triggerHook: 1, duration: 1000})
    .setTween(gsap.fromTo(".special__illustration", { translateY: "50%", duration: 1 }, {translateY: "-15%"}))
    .addTo(specialController);
  new ScrollMagic.Scene({triggerElement: ".special__illustration", triggerHook: 1, duration: 1500})
    .setTween(".section--book:not(.section--book-static)", 1, {translateY: "-30%"})
    .addTo(specialController);
}

let sceneController = new ScrollMagic.Controller();
let sceneParams = {triggerElement: ".artifact", triggerHook: 1, duration: 2000};
new ScrollMagic.Scene(sceneParams)
  .setTween(".artifact__cloud--1,.artifact__cloud--4", 1, {translateX: "-70%"})
  .addTo(sceneController);
new ScrollMagic.Scene(sceneParams)
  .setTween(".artifact__cloud--2,.artifact__cloud--3", 1, {translateX: "70%"})
  .addTo(sceneController);
new ScrollMagic.Scene(sceneParams)
  .setTween(gsap.from(".video-product", { scale: 1.4, duration: 1, ease: "power1.out" }))
  .addTo(sceneController);


let sceneGroup = {triggerElement: ".artifact", triggerHook: 1, duration: 1000};
let animationParams = { scale: .7, duration: 1 };
let movementParams = { translateY: '25%', duration: 1 };
let blackManParams = { translateY: "150%", duration: 1 };
let rocketParams = { translateX: "50%", duration: 1 };

if (isMobile) {
  delete animationParams.scale;
  movementParams.translateY = '10%';
  blackManParams.translateY = '120%';
  rocketParams.translateY = '50%';
}
new ScrollMagic.Scene(sceneGroup)
  .setTween(gsap.from(".artifact__images", animationParams))
  .addTo(sceneController);
new ScrollMagic.Scene({triggerElement: ".artifact .title", triggerHook: 1, duration: 2000})
  .setTween(gsap.to(".artifact__images", movementParams))
  .addTo(sceneController);
new ScrollMagic.Scene(sceneGroup)
  .setTween(gsap.from(".artifact__image--1", { translateY: "50%", duration: 1 }))
  .addTo(sceneController);
new ScrollMagic.Scene(sceneGroup)
  .setTween(gsap.from(".artifact__image--2", blackManParams ))
  .addTo(sceneController);
new ScrollMagic.Scene(sceneGroup)
  .setTween(gsap.from(".artifact__image--3", rocketParams))
  .addTo(sceneController);
new ScrollMagic.Scene(sceneGroup)
  .setTween(gsap.from(".artifact__image--8", { translateX: "-50%", duration: 1 }))
  .addTo(sceneController);
new ScrollMagic.Scene(sceneGroup)
  .setTween(gsap.from(".artifact__image--7", { scale: .8, duration: 1 }))
  .addTo(sceneController);

let castleController = new ScrollMagic.Controller();
let castleSceneParams = {triggerElement: ".special .title", triggerHook: 1, duration: 4000};
let airshipParams = {translateY: "-300%"};
let baloonParams = {translateX: "70%"};
if (isMobile) {
  airshipParams = {translateY: "-200%"};
  baloonParams = {translateX: "-70%", translateY: "-100%"};
} else if (isSmallLaptop) {
  airshipParams = {translateX: "100%"};
}
new ScrollMagic.Scene(castleSceneParams)
  .setTween(".special__img--1", 1, baloonParams)
  .addTo(castleController);
new ScrollMagic.Scene(castleSceneParams)
  .setTween(".special__img--2", 1, {translateX: "30%"})
  .addTo(castleController);
new ScrollMagic.Scene(castleSceneParams)
  .setTween(".special__img--4", 1, {translateX: "90%", translateY: "-300%"})
  .addTo(castleController);
new ScrollMagic.Scene(castleSceneParams)
  .setTween(".special__img--3", 1, airshipParams)
  .addTo(castleController);

if (!isTablet) {
  initSpecialAnimation();
}
